import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-shell__header" }
const _hoisted_2 = {
  id: "export-modal-title",
  class: "modal-shell__title"
}
const _hoisted_3 = ["aria-busy"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "modal-shell__field-label",
  for: "export-filename"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "modal-shell__field-name" }, "Filename")
], -1)
const _hoisted_5 = {
  key: 0,
  id: "export-filename-error",
  class: "export-modal__error"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "export-modal__columns-title" }, "Columns to export", -1)
const _hoisted_7 = { class: "export-modal__columns" }
const _hoisted_8 = { class: "export-modal__options" }
const _hoisted_9 = {
  key: 1,
  class: "export-modal__error"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "export-modal__note" }, "Cleaned values use the original value when no cleaned value is available.", -1)
const _hoisted_11 = {
  key: 2,
  class: "export-modal__error",
  role: "alert"
}
const _hoisted_12 = { class: "modal-shell__actions" }
const _hoisted_13 = { class: "export-modal__progress" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_checkbox = _resolveComponent("n-checkbox")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_spin = _resolveComponent("n-spin")!
  const _component_export_icon = _resolveComponent("export-icon")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createBlock(_component_n_modal, {
    show: _ctx.showModal,
    preset: "card",
    title: "Export CSV",
    "aria-labelledby": "export-modal-title",
    class: "modal-shell export-modal",
    "z-index": _ctx.MODAL_Z_INDEX,
    closable: !_ctx.exporting,
    "close-on-esc": !_ctx.exporting,
    "mask-closable": !_ctx.exporting,
    "onUpdate:show": _ctx.onClose
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, "Exporting \"" + _toDisplayString(_ctx.survey?.name) + "\"", 1)
      ])
    ]),
    action: _withCtx(() => [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_n_button, {
          tertiary: "",
          disabled: _ctx.exporting,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClose(false)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_n_button, {
          class: "modal-shell__primary-button export-modal__submit",
          type: "primary",
          disabled: !_ctx.canExport,
          "attr-type": "submit",
          form: "export-csv-form"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_13, [
              (_ctx.exporting)
                ? (_openBlock(), _createBlock(_component_n_spin, {
                    key: 0,
                    size: 16
                  }))
                : (_openBlock(), _createBlock(_component_n_icon, {
                    key: 1,
                    size: 16,
                    "aria-hidden": "true"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_export_icon)
                    ]),
                    _: 1
                  }))
            ]),
            _createTextVNode(" Export CSV ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        id: "export-csv-form",
        "aria-busy": _ctx.exporting,
        novalidate: "",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onExport && _ctx.onExport(...args)), ["prevent"]))
      }, [
        _hoisted_4,
        _createVNode(_component_n_input, {
          id: "export-filename",
          value: _ctx.filename,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filename) = $event)),
          disabled: _ctx.exporting,
          status: _ctx.filenameStatus,
          "aria-describedby": "export-filename-error"
        }, null, 8, ["value", "disabled", "status"]),
        (!_ctx.validFilename)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Enter a filename."))
          : _createCommentVNode("", true),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
            return (_openBlock(), _createElementBlock("fieldset", {
              key: group.label,
              class: "export-modal__group"
            }, [
              _createElementVNode("legend", null, _toDisplayString(group.label), 1),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.columns, (column) => {
                  return (_openBlock(), _createBlock(_component_n_checkbox, {
                    key: column.id,
                    checked: _ctx.selectedIds.includes(column.id),
                    disabled: _ctx.exporting,
                    "onUpdate:checked": (checked) => _ctx.setSelected(column.id, checked)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.optionLabel(column)), 1)
                    ]),
                    _: 2
                  }, 1032, ["checked", "disabled", "onUpdate:checked"]))
                }), 128))
              ])
            ]))
          }), 128))
        ]),
        (!_ctx.selectedIds.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Select at least one column."))
          : _createCommentVNode("", true),
        _hoisted_10,
        (_ctx.submitError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.submitError), 1))
          : _createCommentVNode("", true)
      ], 40, _hoisted_3)
    ]),
    _: 1
  }, 8, ["show", "z-index", "closable", "close-on-esc", "mask-closable", "onUpdate:show"]))
}